import React, { useCallback } from "react";
import LogDisplay from "components/Interactions/LogDisplay";
import { textMessageLogAPI } from "api/Interactions/TextMessagesAPI";
import { Column } from "components/Data/DataDisplays/GenericTable";

interface TextMessagesBottomDrawerProps {
  textMessageId: number;
}

const TextMessagesBottomDrawer: React.FC<TextMessagesBottomDrawerProps> = ({ textMessageId }) => {
  const fetchLogs = useCallback(() => textMessageLogAPI.getAllByParentId(textMessageId), [textMessageId]);
  
  const columns: Column<any>[] = [
    { field: "timestamp", label: "Timestamp", type: "datetime" },
    { field: "first_name", label: "First Name", type: "text" },
    { field: "last_name", label: "Last Name", type: "text" },
    { field: "phone_number", label: "Phone Number", type: "text" },
    { field: "platform_used", label: "Platform", type: "text" },
    { field: "message_sent", label: "Message Sent", type: "text" },
    { field: "success", label: "Success", type: "boolean" },
  ];
  
  return (
    <LogDisplay
      fetchLogs={fetchLogs}
      columns={columns}
      title="Message Logs"
    />
  );
};

export default TextMessagesBottomDrawer;
